import peterIcon from "../assets/images/icons/Group 49 (1).svg";
import LegacyActivityLayout from "../components/LegacyActivityLayout";
import { useTranslation } from "../components/Localization";

export default function LegacyPeterTaskPage() {
  const { t } = useTranslation();
  return <LegacyActivityLayout taskKey="peter" progressIcon="bottom-left" backTo="/mariaffiek" nextTo="/mariaffiek/cimer">
    <button className="task-icon-button legacy-peter" aria-label={t("accessibility.peterAudio")}><img src={peterIcon} alt="" /></button>
  </LegacyActivityLayout>;
}
